import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { useSelector } from 'react-redux'

import FeatureToggle from '~/constants/featureToggle'
import { getFeatureToggle } from '~/store/reducers/constants'

import { ChatMode, useAgentChat } from './AgentChatContext'
import AgentChatPanel from './AgentChatPanel'
import AgentFab from './AgentFab'
import FloatingChatWindow from './FloatingChatWindow'

const AgentChatManager = () => {
  const { isChatOpen, closeChat, openChat, chatMode } = useAgentChat()

  const isAgentChatEnabled = useSelector(
    getFeatureToggle(FeatureToggle.AGENT_CHAT),
  )

  if (!isAgentChatEnabled || typeof isAgentChatEnabled !== 'boolean') {
    return null
  }

  return (
    <ErrorBoundary
      fallback={<></>}
      onError={(error, errorInfo) => {
        // eslint-disable-next-line no-console
        console.error('Agent Chat Error:', error, errorInfo)
      }}
    >
      {isChatOpen && chatMode === ChatMode.RAIL && (
        <AgentChatPanel closeChat={closeChat} />
      )}
      {isChatOpen && chatMode === ChatMode.FLOATING && <FloatingChatWindow />}
      {!isChatOpen && <AgentFab openChat={openChat} />}
    </ErrorBoundary>
  )
}

export default AgentChatManager
